var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
require('bootstrap-five');
// import * as Popper from "@popperjs/core"
// require('bootstrap-five/js/dist/alert');
// require('bootstrap-five/js/dist/button');
// require('bootstrap-five/js/dist/carousel');
// require('bootstrap-five/js/dist/util');
// require('bootstrap-five/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
// require('bootstrap-five/js/dist/modal');
// require('bootstrap-five/js/dist/popover');
// require('bootstrap-five/js/dist/scrollspy');
// require('bootstrap-five/js/dist/tab');
// require('bootstrap-five/js/dist/tooltip');
import Swiper from 'swiper/bundle';
import Mmenu from 'mmenu-js';

// require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

// require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {


    $(window).on('resize load scroll', function() {

        var headerHeight = $('.navbar--main').outerHeight();
        var scroll = $(window).scrollTop();

        if (scroll >= 130 ) {  //scroll top menu out of view
            $('.navbar--main').addClass("down");
        } else {
            $('.navbar--main').removeClass("down");
        }
    });

    //  $('.page-scroll').bind('click', function(event) {
    $('.page-scroll').on('click', function() {
        var $anchor = $(this);
        var elId = $anchor.attr('href').replace('/', '');

        $('html, body').stop().animate({
            scrollTop: $(elId).offset().top - 130
        }, 250, 'easeInOutExpo');

        event.preventDefault();
    });



    $('#btn-menu').on('click', function() {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });

    //projects slider
   /*  let textCarousel = new Swiper(".panelTextCarousel", {
        modules: [Navigation],

        // autoHeight: true,
        spaceBetween: 30,
        items:1,

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {

            768: {
                slidesPerView: 1,
            },
            1200: {
                slidesPerView: 2,
            }
        },
    }); */

    var swiper = new Swiper(".slidesSwiper", {
        spaceBetween: 0,
        items:1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        /* pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {

            768: {
                slidesPerView: 1,
            },
            1200: {
                slidesPerView: 2,
            }
        }, */
    });
    initProductSlider();



});


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}

function initProductSlider(){

    var swiper = new Swiper(".productSwiper", {
        // direction: "vertical",
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".productSwiper2", {

        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiper,
        },
    });

};

const mmenu = new Mmenu('#mob-menu', {
    'extensions': [
        "pagedim-black"
    ],
}, {
    // configuration
    offCanvas: {
        page: {
                selector: '#offcanvas'
        }
    },
    classNames: {
        selected: "active"
    }
});

const mmenuApi = mmenu.API;
mmenuApi.bind('open:after', function(){
    $('.btn-menu').addClass('open').attr('href','#offcanvas');
});
mmenuApi.bind('close:after', function(){
    $('.btn-menu').removeClass('open').attr('href','#mob-menu');
});
